import { render } from "./DialogSuccess.vue?vue&type=template&id=1004df1a&scoped=true"
import script from "./DialogSuccess.vue?vue&type=script&lang=js"
export * from "./DialogSuccess.vue?vue&type=script&lang=js"

import "./DialogSuccess.vue?vue&type=style&index=0&id=1004df1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1004df1a"

export default script